import { useState } from "react";

import { IconButton } from "@/features/common/components/IconButton";
import { useEditModelAlbumFormDialogContext } from "@/features/modelPhoto/contexts/useEditModelAlbumFormContext";
import CircleCheckIcon from "@/icons/editAlbum/circle_check.svg";
import CircleCheckFilledIcon from "@/icons/editAlbum/circle_check_filled.svg";

export const ReturnModeButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { onSwitchMode } = useEditModelAlbumFormDialogContext();
  const SwitchModeIcon = isHovered ? CircleCheckFilledIcon : CircleCheckIcon;

  return (
    <IconButton
      onClick={onSwitchMode}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="hover:!opacity-100"
    >
      <SwitchModeIcon />
    </IconButton>
  );
};
